import { EntityMetadataMap } from '@ngrx/data';

export const KE_WORKFLOW_PRESETS_ENTITY_NAME = 'ke-workflow-presets';

const entityMetadata: EntityMetadataMap = {
  [KE_WORKFLOW_PRESETS_ENTITY_NAME]: {
    entityDispatcherOptions: { optimisticAdd: false, optimisticUpdate: false },
  },
};

export const workflowPresetsEntityConfig = {
  entityMetadata,
};
